import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.light,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  textLink: {
    color: theme.palette.common.black,
  },
}));
